import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { NormalText } from "../../../../components/TextParts";
import MeetingUrl from "./MeetingUrl";

export default function IntevievLink(props) {
  return (
    <Box>
      <Typography>
        案件名：
        {props.mailSubject}
      </Typography>
      <Typography>
        ステータス：
        {props.status}
      </Typography>
      <Typography paddingBottom="10px">
        最終更新日時：
        {props.updateAt.slice(5, 7) +
          "/" +
          props.updateAt.slice(8, 10) +
          " " +
          props.updateAt.slice(11, 16)}
      </Typography>

      <Box sx={{ display: props.registedAt && props.url ? "normal" : "none" }}>
        <Box sx={{ display: "flex" }}>
          <CheckBoxIcon sx={{ mr: "10px", color: "#28345E" }} />
          <Typography>
            {props.registedAt
              ? props.registedAt.slice(0, 10) +
                "(" +
                props.registedAt.slice(11, 16) +
                ")"
              : "調整中"}
          </Typography>
        </Box>
        <Box>
          <ul style={{ padding: "0 0 0 30px", margin: 0 }}>
            {props.memo && (
              <li style={{ padding: 0, margin: "5px 0 0 0" }}>
                <Box sx={{ pl: "5px" }}>
                  <NormalText text={props.memo ? props.memo : ""}></NormalText>
                </Box>
              </li>
            )}
            <li style={{ padding: 0, margin: "5px 0 0 0" }}>
              <Box sx={{ pl: "5px" }}>
                <MeetingUrl url={props.url} />
              </Box>
            </li>
          </ul>
        </Box>
      </Box>
    </Box>
  );
}
